type IProcedures = Partial<{
    setFreeMode: () => void;
    setFPSMode: () => void;
    set360Mode: () => void;
    setFloor: (floor: string) => void;
    moveTo: (target: string) => void;
}>;

interface IMapProcedures {
    updatePlayer: (data: any) => void;
    updateActiveFloor: (floor: string) => void;
}

class Puzzles {
    public procedures: IProcedures | null = null;
    public mapProcedures: IMapProcedures | null = null;
    public setProcedures(procedures: any) {
        this.procedures = procedures;
    }

    public setMapProcedures(mapProcedures: any) {
        this.mapProcedures = mapProcedures;
    }

    public hasProcedure<K extends keyof NonNullable<IProcedures>>(name: K): boolean {
        return Boolean(this.procedures && typeof (this.procedures as any)[name] === 'function');
    }

    public callProcedure<K extends keyof NonNullable<IProcedures>>(
        name: K,
        ...args: any[]
    ): boolean {
        if (!this.procedures) return false;
        const fn = (this.procedures as any)[name];
        if (typeof fn !== 'function') return false;
        fn(...args);
        return true;
    }

}

const puzzles = new Puzzles();
export default puzzles;
